// src/components/SweetPromoBanner/index.js
// Split image + copy + CTA promotional section (gifting/occasions framing).
// Reuses the store's existing About/banner imagery rather than requiring a
// dedicated "promo image" field that doesn't exist in the API schema. Copy
// is generic marketing language (not a business-specific claim), matching
// how other section variants already fall back to static heading text when
// no config value is supplied.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const SweetPromoBanner = ({ config }) => {
  const navigate = useNavigate();

  const image =
    config?.about?.image ||
    config?.backgroundImages?.banner ||
    config?.gallery?.items?.[0]?.image ||
    '';

  return (
    <section id="promo" className="t16-promo">
      <div className="t16-promo__grid">
        <div className="t16-promo__visual">
          {image && <img src={image} alt="Sweet gift box" className="t16-promo__img" />}
        </div>
        <div className="t16-promo__content">
          <span className="t16-promo__kicker">For Every Occasion</span>
          <h2 className="t16-promo__title">Share Something Sweet</h2>
          <p className="t16-promo__desc">
            From birthdays to festivals, a beautifully packed box of sweets says more than words.
            Order online and have it delivered fresh, wherever the celebration is.
          </p>
          <button
            type="button"
            className="t16-promo__btn"
            onClick={() => navigate('/restaurants')}
          >
            Explore Gifting
          </button>
        </div>
      </div>
    </section>
  );
};

export default SweetPromoBanner;
